import React from "react";
import ContactSection from "../ContactSection/ContactSection";
import Services from "../Services/Services";
import Specialist from "../Specialist/Specialist";
import Banner from "./Banner/Banner";

const Home = () => {
  return (
    <div>
      <Banner></Banner>
      <Services></Services>
      <Specialist></Specialist>
      <ContactSection></ContactSection>
    </div>
  );
};

export default Home;
